export class ActionAsideMenuOpenClose {
  static readonly type = '[AsideMenu] open close';
  constructor(public isOpen: boolean) {}
}
